import ContratEditBaseSalarie from '@/generated/controls/contrat/ContratEditBaseSalarie.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ContratEditBaseSalarie
})
